import { render, staticRenderFns } from "./KnowledgeProcessForm.vue?vue&type=template&id=5eebe13f&"
import script from "./KnowledgeProcessForm.vue?vue&type=script&lang=js&"
export * from "./KnowledgeProcessForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "KnowledgeProcessForm.vue"
export default component.exports